<!-- ===== HERO / CAPA ===== -->
<section class="home-hero" [class.is-mobile]="mobileQuery.matches">
  <div class="home-hero__inner">
    <div class="home-hero__badge">
      <img src="../assets/HomeHeroVersaoBeta.png" alt="versão beta" />
    </div>
    <div class="home-hero__text">
      <h1 class="home-hero__title">
        Conectamos profissionais da saúde às melhores oportunidades do mercado
      </h1>
      <p class="home-hero__subtitle">
        A solução completa para médicos, hospitais e prestadores de serviços de saúde.
      </p>
    </div>
  </div>
</section>

<!-- ===== COMO FAZEMOS ===== -->
<section class="home-steps" [class.is-mobile]="mobileQuery.matches">
  <div class="home-steps__grid">

    <div class="card home-steps__card">
      <div class="home-steps__icon">
        <img src="assets/icons/icon_comofazer_1.svg" alt="Ícone cadastro validado" />
      </div>
      <h3 class="card-title">Cadastro Validado</h3>
      <p class="card-body">
        Profissionais e empresas se cadastram com documentos verificados,
        garantindo segurança e confiança.
      </p>
    </div>

    <div class="card home-steps__card">
      <div class="home-steps__icon">
        <img src="assets/icons/icon_comofazer_2.svg" alt="Ícone verificação inteligente" />
      </div>
      <h3 class="card-title">Verificação Inteligente</h3>
      <p class="card-body">
        Integração com conselhos e órgãos oficiais e revisão por atendentes do HubMedical.
      </p>
    </div>

    <div class="card home-steps__card">
      <div class="home-steps__icon">
        <img src="assets/icons/icon_comofazer_3.svg" alt="Ícone conexão segura" />
      </div>
      <h3 class="card-title">Conexão Segura</h3>
      <p class="card-body">
        Busque ou publique serviços com segurança e receba alertas de validade documental.
      </p>
    </div>

  </div>
</section>

<!-- ===== SOBRE A PLATAFORMA ===== -->
<section class="home-about" [class.is-mobile]="mobileQuery.matches">
  <div class="card card-dark home-about__card">
    <div class="home-about__logo">
      <img src="assets/Home_section-info_logo.svg" alt="Logo HubMedical" />
    </div>
    <div class="home-about__text">
      <p>
        O HubMedical é uma plataforma digital que conecta profissionais da saúde e
        estabelecimentos certificados em todo o Brasil. Nosso compromisso é garantir relações
        seguras, transparentes e legalmente verificadas no setor da saúde.
      </p>
      <p>
        Com um sistema robusto de validação documental e gestão de ofertas e demandas, tornamos
        o processo de contratação e prestação de serviços mais ágil, confiável e seguro.
      </p>
    </div>
  </div>
</section>

<!-- ===== EXPERIÊNCIA RESPONSIVA ===== -->
<section class="home-responsive">
  <div class="home-responsive__inner">
    <h2 class="title-section">Experiência Responsiva e Intuitiva</h2>

    <div class="home-responsive__flex">
      <div class="home-responsive__screens">
        <img src="assets/AplicativoTelas.png" alt="Telas do aplicativo HubMedical" />
      </div>

      <div class="home-responsive__content">
        <div class="home-responsive__heading">
          <h3>Facilidade de uso</h3>
          <p>Design clean, navegação intuitiva e foco em resultado.</p>
        </div>

        <div class="home-features__grid">
          <div class="card home-features__item">
            <div class="home-features__icon">
              <img src="assets/icons/icon_certificados.svg" alt="verificado" />
            </div>
            <p>Cadastro simples e verificado</p>
          </div>

          <div class="card home-features__item">
            <div class="home-features__icon">
              <img src="assets/icons/icon_ofertas.svg" alt="busca" />
            </div>
            <p>Buscas e ofertas em tempo real</p>
          </div>

          <div class="card home-features__item">
            <div class="home-features__icon">
              <img src="assets/icons/icon_shareDoc.svg" alt="documentos" />
            </div>
            <p>Gestão e compartilhamento de documentos</p>
          </div>

          <div class="card home-features__item">
            <div class="home-features__icon">
              <img src="assets/icons/icon_notif.svg" alt="alertas" />
            </div>
            <p>Alertas automáticos de validade</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ===== PLANOS ===== -->
<app-shopping-card></app-shopping-card>

<!-- ===== FAQ ===== -->
<section class="home-faq" [class.is-mobile]="mobileQuery.matches">
  <div class="home-faq__header">
    <div class="home-faq__icon">
      <img src="assets/icons/icon_home_FAQ.svg" alt="Ícone perguntas frequentes" />
    </div>
    <p class="home-faq__intro">
      Aqui estão algumas das perguntas mais feitas pelos nossos usuários. Para uma versão mais
      compreensiva da ajuda, acesse a seção de perguntas frequentes (FAQ) no link à esquerda, e
      caso já seja assinante e ainda não encontre a resposta para a sua dúvida, entre em contato
      com o nosso SAC no link mais abaixo.
    </p>
  </div>

  <div class="home-faq__grid">
    <!-- Coluna 1 -->
    <div class="home-faq__col">
      <div class="card home-faq__item">
        <div class="home-faq__question">
          <img src="assets/icons/icon_home_FAQ.svg" alt="FAQ" />
          <strong>O que é a HubMedical?</strong>
        </div>
        <p class="card-body">
          É uma plataforma digital que conecta profissionais da saúde e instituições
          certificadas, promovendo oportunidades seguras e verificadas.
        </p>
      </div>

      <div class="card home-faq__item">
        <div class="home-faq__question">
          <img src="assets/icons/icon_home_FAQ.svg" alt="FAQ" />
          <strong>Quem pode se cadastrar?</strong>
        </div>
        <p class="card-body">
          Profissionais da saúde registrados em conselhos regionais e estabelecimentos com
          cadastro ativo no CNES.
        </p>
      </div>

      <div class="card home-faq__item">
        <div class="home-faq__question">
          <img src="assets/icons/icon_home_FAQ.svg" alt="FAQ" />
          <strong>Preciso pagar para usar a HubMedical?</strong>
        </div>
        <p class="card-body">
          Não. Durante a versão Beta, o acesso é totalmente gratuito. Após essa fase, haverá
          planos anuais com pagamento mensal e 30 dias gratuitos para novos usuários.
        </p>
      </div>

      <div class="card home-faq__item">
        <div class="home-faq__question">
          <img src="assets/icons/icon_home_FAQ.svg" alt="FAQ" />
          <strong>Quais perfis estão disponíveis?</strong>
        </div>
        <p class="card-body">
          Você pode se cadastrar como Profissional da Saúde (Pessoa Física), Estabelecimento
          de Saúde (Pessoa Jurídica) ou Contratante de Consultas.
        </p>
      </div>

      <div class="card home-faq__item">
        <div class="home-faq__question">
          <img src="assets/icons/icon_home_FAQ.svg" alt="FAQ" />
          <strong>Como funciona a verificação de documentos?</strong>
        </div>
        <p class="card-body">
          A validação é feita por meio de integração com órgãos oficiais e revisão por
          atendentes especializados do HubMedical.
        </p>
      </div>
    </div>

    <!-- Coluna 2 -->
    <div class="home-faq__col">
      <div class="card home-faq__item">
        <div class="home-faq__question">
          <img src="assets/icons/icon_home_FAQ.svg" alt="FAQ" />
          <strong>A plataforma avisa quando meus documentos estão vencendo?</strong>
        </div>
        <p class="card-body">
          Sim. Todos os perfis recebem alertas automáticos sobre vencimento de documentos.
        </p>
      </div>

      <div class="card home-faq__item">
        <div class="home-faq__question">
          <img src="assets/icons/icon_home_FAQ.svg" alt="FAQ" />
          <strong>Instituições podem buscar profissionais?</strong>
        </div>
        <p class="card-body">
          Sim. Estabelecimentos e contratantes de serviço podem pesquisar perfis verificados
          e publicar demandas.
        </p>
      </div>

      <div class="card home-faq__item">
        <div class="home-faq__question">
          <img src="assets/icons/icon_home_FAQ.svg" alt="FAQ" />
          <strong>Posso publicar minhas ofertas de consultas e procedimentos?</strong>
        </div>
        <p class="card-body">
          Sim. Profissionais podem criar e gerenciar suas próprias ofertas diretamente na
          plataforma, desde que estejam com sua documentação em dia e validada.
        </p>
      </div>

      <div class="card home-faq__item">
        <div class="home-faq__question">
          <img src="assets/icons/icon_home_FAQ.svg" alt="FAQ" />
          <strong>A HubMedical garante os acordos entre usuários?</strong>
        </div>
        <p class="card-body">
          Não. A plataforma valida documentos e facilita conexões, mas não se responsabiliza
          por acordos firmados entre as partes.
        </p>
      </div>

      <div class="card home-faq__item">
        <div class="home-faq__question">
          <img src="assets/icons/icon_home_FAQ.svg" alt="FAQ" />
          <strong>Como posso acessar o HubMedical?</strong>
        </div>
        <p class="card-body">
          Via navegador ou instalando o aplicativo PWA em seu dispositivo móvel ou desktop.
          O acesso é simples e seguro.
        </p>
      </div>
    </div>
  </div>

  <div class="home-faq__sac">
    <img src="assets/SAC-SuporteSempreDiponivel.png" alt="SAC - Suporte Sempre Disponível" />
  </div>
</section>

<!-- ===== FOOTER ===== -->
<footer class="home-footer">
  <div class="home-footer__inner">
    <div class="home-footer__main">

      <div class="home-footer__brand">
        <img src="assets/Hubmedical-Logo-2026-Fundo-Escuro.svg" alt="HubMedical Logo" class="home-footer__logo" />
        <p class="home-footer__tagline">Conexões Entre os Profissionais de Saúde</p>
        <address class="home-footer__address">
          <p>Rua Corticeira da Serra, nº 71 , Florianópolis/SC</p>
          <p>CEP: 88.056-368 — CNPJ: 27.390.450/0001-94</p>
        </address>
      </div>

      <div class="home-footer__contact">
        <a class="home-footer__contact-item" href="https://wa.me/5548991074004" target="_blank" rel="noopener">
          <img src="assets/icons/whatsapp-icon.svg" alt="WhatsApp" />
          <span>(48) 99107 4004</span>
        </a>
        <a class="home-footer__contact-item" href="https://instagram.com/HUBmedical" target="_blank" rel="noopener">
          <img src="assets/icons/instagram-icon.svg" alt="Instagram" />
          <span>&#64;HUBmedical</span>
        </a>
        <a class="home-footer__contact-item" href="mailto:atendimento@hubmedical.com.br">
          <img src="assets/icons/email-icon.svg" alt="Email" />
          <span>atendimento&#64;hubmedical.com.br</span>
        </a>
        <a class="home-footer__contact-item" href="https://facebook.com/hubmedical" target="_blank" rel="noopener">
          <img src="assets/icons/facebook-icon.svg" alt="Facebook" />
          <span>hubmedical</span>
        </a>
      </div>

      <div class="home-footer__links">
        <h6>Links Úteis</h6>
        <button type="button" class="btn btn-ghost home-footer__link-btn"
          (click)="openTermsDialog()" aria-label="Ver Termos e Regras de Uso">
          Termos de Uso
        </button>
        <button type="button" class="btn btn-ghost home-footer__link-btn"
          (click)="openPrivacyPolicyDialog()" aria-label="Ver Política de Privacidade">
          Política de Privacidade
        </button>
      </div>

    </div>

    <div class="home-footer__bottom">
      <p>&copy; 2024 HubMedical. Todos os direitos reservados.</p>
    </div>
  </div>
</footer>